module.exports = __webpack_public_path__ + "img/instagram copy.2277f5f9.svg";